import { getAuthTokenFromQueryParams } from 'util/getAuthTokenFromQueryParams';
import { useEffect, useState } from 'react';
import { authStore } from 'state/store';
import { selectAuthToken, selectIsHydrated } from 'state/selectors';
import { useHistory } from 'react-router-dom';

export const useAuthorize = () => {
    const [isProcessingCompleted, setIsProcessingCompleted] = useState(false);

    const authToken = selectAuthToken();
    const isHydrated = selectIsHydrated();
    const history = useHistory();

    useEffect(() => {
        if (!isHydrated) {
            return;
        }

        const params = new URLSearchParams(history.location.search);

        // достаем только авторизационный токен
        const authTokenFromQueryParam = getAuthTokenFromQueryParams();

        /**
         * если токена нет И токен пришел в query params - сохраняем его,
         * если токена нет И токена НЕТ в query params - редирект на логин
         */
        if (!authToken && authTokenFromQueryParam) {
            authStore.setAuthToken(authTokenFromQueryParam);
        }

        // подчищаем авторизационный токен, если он есть в query params
        if (authTokenFromQueryParam) {
            params.delete('token');
            history.replace({
                search: params.toString(),
            });
        }

        setIsProcessingCompleted(true);
    }, [authToken, history, isHydrated]);

    return {
        /**
         * isProcessingCompleted показывает, завершен ли процесс получения\обработки токена в данный момент.
         * Начальное состояние = false, флаг зависит от следующих вещей, которые обрабатываются не синхронно:
         * - isHydrated (mobx store)
         * - логика обработки URL query params - в useEffect, который сработает только после первого render,
         */
        isProcessingCompleted,
        isAuthorized: Boolean(authToken),
    };
};
